import React, { createContext, useContext } from "react";

const ApiContext = createContext();

export const ApiProvider = ApiContext.Provider;

export const useApi = () => useContext(ApiContext);
